// Convert text to number
export function stringToNumber(text: string) {
    return text.split('').reduce((acc: number, char: string) => {
        const code = char.charCodeAt(0) || 0;
        return acc + code;
    }, 0);
}
